export var CHAT_MODE_BOT = 'CHAT_MODE_BOT';
export var CHAT_MODE_REAL = 'CHAT_MODE_REAL';
export var CAMPAIGN_DECO = 'CAMPAIGN_DECO';
export var CAMPAIGN_SALES = 'CAMPAIGN_SALES';